import { E_Route } from "utils/constants";
import {
  LoginScreen,
  AfterLoginScreen,
  OnboardingScreen,
  PodcastScreen,
  DashboardLayout,
  ActivityScreen,
  MeetingScreen,
  MyAccountScreen,
  IntegrationScreen,
  ManageBillingScreen,
  DoneScreen,
  NotificationsSreen,
  CalendarScreen,
  NotFoundPage,
  TranscriptListScreen,
  MeetingTranscriptScreen,
  AssistantSetupSreen,
  SettingsNavigationScreen,
} from "features";
import { TodoScreen } from "features/todos";

export const PublicPages = [
  {
    path: E_Route.AuthBegin,
    element: <LoginScreen />,
  },
  {
    path: E_Route.AuthContinue,
    element: <AfterLoginScreen />,
  },
  {
    path: E_Route.Meeting,
    element: <PodcastScreen />,
  },
  {
    path: E_Route.Done,
    element: <DoneScreen />,
  },
  {
    path: E_Route.Warning,
    element: <DoneScreen />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export const PrivatePages = [
  {
    path: E_Route.Home,
    element: <DashboardLayout />,
  },
  {
    path: E_Route.Onboarding,
    element: <OnboardingScreen />,
  },
  {
    path: E_Route.Meeting + "/:meetingId",
    element: <MeetingScreen />,
  },
  {
    path: E_Route.Activity,
    element: <ActivityScreen />,
  },
  {
    path: E_Route.ManageCredits,
    element: <ManageBillingScreen />,
  },
  {
    path: E_Route.Podcast,
    element: <PodcastScreen />,
  },
  {
    path: E_Route.Calendar,
    element: <CalendarScreen />,
  },
  {
    path: E_Route.Todos,
    element: <TodoScreen />,
  },
  {
    path: E_Route.Transcript,
    element: <TranscriptListScreen />,
  },
  {
    path: E_Route.MeetingTranscript + "/:id",
    element: <MeetingTranscriptScreen />,
  },
];

export const SettingPages = [
  {
    path: E_Route.Settings,
    element: <SettingsNavigationScreen />,
    index: true,
  },
  {
    path: E_Route.MyAccount,
    element: <MyAccountScreen />,
  },
  {
    path: E_Route.ManageBilling,
    element: <ManageBillingScreen />,
  },
  {
    path: E_Route.Services,
    element: <IntegrationScreen />,
  },
  {
    path: E_Route.Notifications,
    element: <NotificationsSreen />,
  },
  {
    path: E_Route.MeetingBotSetting,
    element: <AssistantSetupSreen />,
  },
];

// const Pages = PrivatePages.concat(PublicPages);
